import { Box, Grid, Typography } from '@mui/material'
import React from 'react'
import HalfSizeBanner from '../components/Banners/HalfSizeBanner'
import TextBtnSection from '../components/Section/TextBtnSection'
import ContentCard from '../components/Cards/ContentCard'
import ProgressCarousel from '../components/Carousel/ProgressCarousel'
import { useTranslation } from '../hook/Translation'
// import Accordions from '../components/Accordions/Accordions'

export default function NailBar() {
    const { t } = useTranslation();
    const OPTIONS = { dragFree: true }
    // const SLIDE_COUNT = 5
    const SLIDES = [
        {
            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2026/03/fb816af98d9e6e17de259a97a59a872b.png`,
            text: "CLASSIC PEDICURE",
            desc: t('nail_bar.CLASSIC_PEDICURE_desc'),
            price: `${t('price')}: €25`
        },
        {
            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2026/03/1.png`,
            text: "NATURAL NAILS (GLOSSIFY)",
            desc: t('nail_bar.NATURAL_NAILS_PEDICURE_desc'),
            price: `${t('price')}: €25`
        },
        {
            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2026/03/2.png`,
            text: "ADVANCED PEDICURE",
            desc: t('nail_bar.ADVANCED_PEDICURE_desc'),
            price: `${t('price')}: €35`
        },
        {
            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2026/03/3.png`,
            text: "ART / DESIGN (GLOSSIFY)",
            desc: t('nail_bar.ART_DESIGN_PEDICURE_desc'),
            price: `${t('price')}: €5-10`
        },
        {
            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2026/03/Luxr.png`,
            text: "LUXURY PEDICURE",
            desc: t('nail_bar.LUXURY_PEDICURE_desc'),
            price: `${t('price')}: €45`
        },
        {
            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2026/03/1-1.png`,
            text: "RINU PEDICURE (+ NAILS)",
            desc: t('nail_bar.RINU_PEDICURE_desc'),
            price: `${t('price')}: €60`
        }
    ]

    const SLIDES2 = [
        {
            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2026/03/123.png`,
            text: "PEDICURE FOR MEN",
            desc: t('nail_bar.PEDICURE_FOR_MEN_desc'),
            price: `${t('price')}: €45`
        },
        {
            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2026/05/img_6a02f7d3947505.42585661.png`,
            text: "MANICURE FOR MEN",
            desc: t('nail_bar.MANICURE_FOR_MEN_desc'),
            price: `${t('price')}: €15`
        }
    ]

    const nailBars = [
        {
            data: {
                imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2026/03/Extension-with-tip.png`,
                title: "Natural nails (Glossify)",
                description: t('nail_bar.natural_nails_desc'),
                price: "€20",
                direction: { md: 'row-reverse', xs: 'column-reverse' },
                book: `https://wa.me/+383049909090?text=${encodeURIComponent("Pershendetje, dua të rezervoj seancën për Menicure: Natural nails (Glossify)")}`
            },
            height: { md: '440px', xs: 'auto' }
        },
        {
            data: {
                imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2026/03/Natural-Nails-with-Gel.png`,
                title: "Nails with builder base (Glossify)",
                description: t('nail_bar.nails_with_builder_base_desc'),
                price: "€25",
                // direction: { md: 'row-reverse', xs: 'row' },
                book: `https://wa.me/+383049909090?text=${encodeURIComponent("Pershendetje, dua të rezervoj seancën për Menicure: Nails with builder base (Glossify)")}`
            },
            height: { md: '440px', xs: 'auto' }
        },
        {
            data: {
                imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2026/03/Mega-base.png`,
                title: "Mbushje me xhel (Refill)",
                description: t('nail_bar.refill_desc'),
                price: "€27",
                direction: { md: 'row-reverse', xs: 'column-reverse' },
                book: `https://wa.me/+383049909090?text=${encodeURIComponent("Pershendetje, dua të rezervoj seancën për Menicure: Mbushje me xhel (Refill)")}`
            },
            height: { md: '440px', xs: 'auto' }
        },
        {
            data: {
                imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2026/03/French.png`,
                title: "Extension with tips",
                description: t('nail_bar.extension_with_tips_desc'),
                price: "€35",
                // direction: { md: 'row-reverse', xs: 'row' },
                book: `https://wa.me/+383049909090?text=${encodeURIComponent("Pershendetje, dua të rezervoj seancën për Menicure: Extension with tips")}`
            },
            height: { md: '440px', xs: 'auto' }
        },
        {
            data: {
                imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2026/03/French-1.png`,
                title: "Nail extension with gel",
                description: t('nail_bar.nail_extension_with_gel_desc'),
                price: "€40",
                direction: { md: 'row-reverse', xs: 'column-reverse' },
                book: `https://wa.me/+383049909090?text=${encodeURIComponent("Pershendetje, dua të rezervoj seancën për Menicure: Nail extension with gel")}`
            },
            height: { md: '440px', xs: 'auto' }
        },
        {
            data: {
                imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2026/03/French-2.png`,
                title: "Art / Design (Glossify)",
                description: t('nail_bar.art_design_desc'),
                price: "€5-10",
                // direction: { md: 'row-reverse', xs: 'row' },
                book: `https://wa.me/+383049909090?text=${encodeURIComponent("Pershendetje, dua të rezervoj seancën për Menicure: Art / Design (Glossify)")}`
            },
            height: { md: '440px', xs: 'auto' }
        },
        {
            data: {
                imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2026/03/French-3.png`,
                title: "Classic Manicure",
                description: t('nail_bar.classic_manicure_desc'),
                price: "€15",
                direction: { md: 'row-reverse', xs: 'column-reverse' },
                book: `https://wa.me/+383049909090?text=${encodeURIComponent("Pershendetje, dua të rezervoj seancën për Menicure: Classic Manicure")}`
            },
            height: { md: '440px', xs: 'auto' }
        },
        // {
        //     data: {
        //         imageUrl: "${process.env.REACT_APP_SITE_URL}/images/2026/03/French-4.png",
        //         title: "Thonj natyral",
        //         description: "Aplikim i llakut xhel mbi thonjët natyralë për një finisë të pastër dhe afatgjatë. Forcon, mbron dhe i mban thonjët me pamje natyrale dhe të kujdesura.",
        //         price: "€20",
        //         // direction: { md: 'row-reverse', xs: 'row' },
        //         book: '/'
        //     },
        //     height: { md: '440px', xs: 'auto' }
        // }
    ]

    return (
        <Box>
            <Box>
                <HalfSizeBanner>
                    <Box height={'100%'} bgcolor={'text.secondary'}>
                        <Box component={'img'} src={'${process.env.REACT_APP_SITE_URL}/images/2026/03/nailbar.png'} alt='Nail Bar' loading='lazy' height={1} width={1} className="fitCover" />
                    </Box>
                </HalfSizeBanner>
            </Box>

            <Box className="generalContainer" marginX={'auto'} marginTop={{ md: '80px', xs: '50px' }}>
                <TextBtnSection
                    titleSize={{ md: 6, xs: 12 }}
                    // descriptionSize={{}}
                    data={{
                        type: "Nail Bar",
                        title: "Manicure & Pedicure",
                        description:  t('nail_bar.mainDesc'),
                        bookUrl: "/booknow",
                    }}
                />
            </Box>
            <Box marginTop={{ md: '107px', xs: '50px' }}>
                <Box component={'img'} src='/images/fractional/Path 134.svg' width={1} sx={{ objectFit: 'cover' }} />
            </Box>
            <Box className="generalContainer" marginX={'auto'} marginTop={{ md: '80px', xs: '50px' }}>
                <Box>
                    <Typography fontSize={{ md: '46px', xs: '30px' }} color='text.secondary' fontWeight={'600'} fontFamily={'DanmarkURW'} textAlign={'center'} >Manicure</Typography>
                </Box>
            </Box>
            <Box>
                <Grid container gap={{ md: '89px', xs: '50px' }} className="generalContainer" marginX={'auto'} paddingTop={{ md: '100px', xs: '50px' }} paddingBottom={{ md: '188px', xs: '50px' }}>
                    {
                        nailBars.map((data, index) => (
                            <Grid size={12} key={index}>
                                <ContentCard
                                    data={{
                                        imageUrl: data.data.imageUrl,
                                        title: data.data.title,
                                        description: data.data.description,
                                        direction: data.data.direction,
                                        price: data.data.price,
                                        // learn: "/skin/fractional-co2-resurfacing",
                                        book: data.data.book
                                    }}
                                    target={'_blank'}
                                    heigth={{ md: '440px', xs: 'auto' }}
                                />
                            </Grid>
                        ))
                    }
                </Grid>
            </Box>
            <Grid container position={'relative'} sx={{ marginLeft: 'auto', width: { lg: '80%', xs: '100%' }, marginBottom: { md: '100px', xs: '50px' } }}>
                <Grid size={12}>
                    <Typography fontSize={{ md: '46px', xs: '30px' }} color='text.secondary' fontWeight={'600'} fontFamily={'DanmarkURW'}>Pedicure</Typography>
                </Grid>
                <Grid size={12} mt={{ md: '80px', xs: '50px' }}>
                    <ProgressCarousel slides={SLIDES} options={OPTIONS} buttonSize={{ lg: 6, md: 6, sm: 8, xs: 12 }} maxWidth={{ md: '100%', xs: '90%' }} />
                </Grid>
            </Grid>

            <Grid container position={'relative'} sx={{ marginLeft: 'auto', width: { lg: '80%', xs: '100%' }, marginBottom: { md: '100px', xs: '50px' } }}>
                <Grid size={12}>
                    <Typography fontSize={{ md: '46px', xs: '30px' }} color='text.secondary' fontWeight={'600'} fontFamily={'DanmarkURW'}>Pedicure për Man</Typography>
                </Grid>
                <Grid size={12} mt={{ md: '50px', xs: '50px' }}>
                    <ProgressCarousel slides={SLIDES2} noUnderLine={true} options={OPTIONS} buttonSize={{ lg: 6, md: 6, sm: 8, xs: 12 }} maxWidth={{ md: '100%', xs: '90%' }} />
                </Grid>
            </Grid>

            {/* <Grid container gap={{md: '80px'}} className='generalContainer' sx={{ marginX: 'auto', marginTop: {md: '90px'}, marginBottom: {md: '100px', xs: 'none'} }}>
                <Grid size={12}>
                    <Typography textAlign={'center'} variant="body1" color="text.secondary" fontSize={'1.125rem'} fontWeight={'600'}>{t('additional_information')}</Typography>
                </Grid>
                <Grid size={12}>
                    <Accordions data={accodirons} />
                </Grid>
            </Grid> */}

        </Box>
    )
}